@if (icon) {
  <campus-icon [svgIcon]="icon" class="fab-button-icon icon-current" [class]="iconClass"></campus-icon>
}
@if (label) {
  <span class="[ label-large ][ on-primary-container ]">{{ label }}</span>
}

@if (plainTooltip) {
  <campus-tooltip
    [plainTooltip]="plainTooltip"
    [tooltipDelay]="250"
    [anchor]="element"
    class="[ visually-hidden ]"
    >
  </campus-tooltip>
}

@if (badge) {
  <dcr-badge [count]="badge" class="[ absolute -top-3xs -right-3xs ]"></dcr-badge>
}

<dcr-state-layer class="bg-on-primary-container" [for]="element"></dcr-state-layer>
<dcr-focus-ring [for]="element"></dcr-focus-ring>
